module.exports = __webpack_public_path__ + "c8f980ff6f1da73b5bcadd789a824e5b.svg";